// extracted by mini-css-extract-plugin
export default {"modalContainer":"ErrorModal_modalContainer__l3M+d","modal":"ErrorModal_modal__HpYbB","titleContainer":"ErrorModal_titleContainer__yDnC8"};